"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var ODR_URL = 'https://ec.europa.eu/consumers/odr';
exports.EUODRAddressFragment = graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  fragment EUODRAddress on Shop {\n    vatId\n    euOdrAddress {\n      name\n      streetAddress\n      displayLocation\n      postalCode\n      email\n      phone\n    }\n  }"], ["\n  fragment EUODRAddress on Shop {\n    vatId\n    euOdrAddress {\n      name\n      streetAddress\n      displayLocation\n      postalCode\n      email\n      phone\n    }\n  }"])));
/**
 * Adds an EU ODR details widget to any query context
 * that has access to a shop. See the container below
 * if you need something self contained.
 */
function EUODRDetails(props) {
    if (!props.shop) {
        return null;
    }
    var _a = props.shop, euOdrAddress = _a.euOdrAddress, vatId = _a.vatId;
    if (!euOdrAddress) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("p", null,
                I18n.t('discovery.euOdrDetails.requiredInfo'),
                ": ",
                React.createElement("a", { href: ODR_URL, target: "_blank", rel: "noopener noreferrer" }, ODR_URL))),
        React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, I18n.t('discovery.euOdrDetails.name')),
                    React.createElement("td", null, euOdrAddress.name)),
                React.createElement("tr", null,
                    React.createElement("td", null, I18n.t('discovery.euOdrDetails.address')),
                    React.createElement("td", null,
                        euOdrAddress.streetAddress,
                        euOdrAddress.displayLocation,
                        euOdrAddress.postalCode)),
                React.createElement("tr", null,
                    React.createElement("td", null, I18n.t('discovery.euOdrDetails.email')),
                    React.createElement("td", null, euOdrAddress.email)),
                React.createElement("tr", null,
                    React.createElement("td", null, I18n.t('discovery.euOdrDetails.phone')),
                    React.createElement("td", null, euOdrAddress.phone)),
                vatId && React.createElement("tr", null,
                    React.createElement("td", null, I18n.t('discovery.euOdrDetails.vatId')),
                    React.createElement("td", null, vatId))))));
}
exports.EUODRDetails = EUODRDetails;
var withQuery = react_apollo_1.graphql(graphql_tag_1.default(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    query Core_Listing_EuOdrAddress(\n      $slug: String\n    ) {\n      shop(input: {slug: $slug}) {\n        ...EUODRAddress\n      }\n    }\n    ", "\n  "], ["\n    query Core_Listing_EuOdrAddress(\n      $slug: String\n    ) {\n      shop(input: {slug: $slug}) {\n        ...EUODRAddress\n      }\n    }\n    ", "\n  "])), exports.EUODRAddressFragment), {
    options: function (ownProps) {
        return {
            errorPolicy: 'all',
            variables: {
                slug: ownProps.shopSlug,
            },
        };
    },
});
/**
 * This wrapped container should only be used when this
 * component has to be truly standalone (e.g. in core).
 * Prefer using the fragment driven component when
 * possible.
 */
function EUODRDetailsContainer(props) {
    if (!props.data) {
        return null;
    }
    if (props.data.loading) {
        return null;
    }
    return React.createElement(EUODRDetails, { shop: props.data.shop });
}
exports.default = withQuery(EUODRDetailsContainer);
var templateObject_1, templateObject_2;
//# sourceMappingURL=eu_odr_details.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/eu_odr_details.js
// module id = kFQh
// module chunks = 20 21